"use strict";

require("core-js/modules/es6.string.fixed");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var util_1 = require("./util");

var AssetType;

(function (AssetType) {
  AssetType["Image"] = "Image";
  AssetType["Video"] = "Video";
  AssetType["Unknown"] = "Unknown";
})(AssetType = exports.AssetType || (exports.AssetType = {}));

var NullAssetAccessor =
/** @class */
function () {
  function NullAssetAccessor() {}

  NullAssetAccessor.prototype.url = function (defaultValue) {
    return defaultValue;
  };

  NullAssetAccessor.prototype.fluid = function (opts) {
    return util_1.createFallbackFluidImageObject(opts && opts.fallbackImage);
  };

  NullAssetAccessor.prototype.fixed = function (opts) {
    return util_1.createFallbackFixedImageObject(opts && opts.fallbackImage);
  };

  NullAssetAccessor.prototype.title = function () {
    return undefined;
  };

  NullAssetAccessor.prototype.type = function () {
    return AssetType.Unknown;
  };

  return NullAssetAccessor;
}();

exports.NullAssetAccessor = NullAssetAccessor;

var NullFileAccessor =
/** @class */
function (_super) {
  __extends(NullFileAccessor, _super);

  function NullFileAccessor() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return NullFileAccessor;
}(NullAssetAccessor);

exports.NullFileAccessor = NullFileAccessor;